


























































































import { defineComponent, ref, watchEffect, Ref, PropType } from '@vue/composition-api';
import OlbButton from '../button/button.vue';
import OlbCarousel from '../carousel/carousel.vue';
import OlbDialog from '../dialog/dialog.vue';
import OlbIcon from '../icon/icon.vue';
import OlbImage from '../image/image.vue';

interface ImageSource {
	desktop: string;
	mobile: string;
}

interface GalleryImage {
	src: ImageSource;
	alt: string;
	zoom: string;
	caption: string;
}

export default defineComponent({
	props: {
		images: {
			type: Array as PropType<GalleryImage[]>,
			required: true,
		},
		imagesLength: String,
		imageLink: String,
		showCaptionLabel: String,
		hideCaptionLabel: String,
	},
	components: {
		OlbButton,
		OlbCarousel,
		OlbDialog,
		OlbIcon,
		OlbImage,
	},
	setup(props) {
		const hasCaption: Ref<boolean> = ref(false);
		const isCaptionOpen: Ref<boolean> = ref(true);
		const isCarouselOpen: Ref<boolean> = ref(false);
		const carouselIndex: Ref<number> = ref(1);
		const imagesCaption = props.images.map((image: GalleryImage) => image.caption);
		const showCaptionLabelWithDefault = props.showCaptionLabel || 'Bildunterschrift einblenden';
		const hideCaptionLabelWithDefault = props.hideCaptionLabel || 'Bildunterschrift ausblenden';

		/* Carousel component needs to start after the dialog slot content opens, otherwise the flickity
        won't resize the images and won't show the images until the user moves the screen.
        https://github.com/metafizzy/flickity/issues/318 */
		function onClick() {
			setTimeout(() => {
				isCarouselOpen.value = true;
			}, 100);
		}

		watchEffect(() => {
			if (!imagesCaption) {
				return;
			}
			const captionValue = imagesCaption[carouselIndex.value - 1];
			captionValue !== undefined && captionValue !== '' ? (hasCaption.value = true) : (hasCaption.value = false);
		});

		function toggleCaption() {
			isCaptionOpen.value = !isCaptionOpen.value;
		}

		function getIndex(index: string) {
			parseInt(index) === 0 ? (carouselIndex.value = 1) : (carouselIndex.value = parseInt(index + 1));
		}

		return {
			imagesGallery: props.images,
			imagesCaption,
			isCarouselOpen,
			carouselIndex,
			hasCaption,
			isCaptionOpen,
			showCaptionLabelWithDefault,
			hideCaptionLabelWithDefault,
			getIndex,
			toggleCaption,
			onClick,
		};
	},
});
